// Clarkson University's undergraduate majors (#2748). Read on 2026-10-01 from
// Clarkson's official program finder (clarkson.edu/academics/majors-minors,
// filtered to Undergraduate Education; the page loads its list from
// clarkson.edu/api/programs.json). Clarkson posts no online undergraduate
// catalog at a .edu address we could reach. Every program the finder lists as
// a Major is kept, except: Occupational Therapy, Physical Therapy and
// Physician Assistant Studies (their pages describe a BS in another major
// followed by direct entry to a graduate program, not a bachelor's major of
// that name), and University Studies, Engineering Studies and Science Studies
// (first-year exploratory options before choosing a major). The degree is the
// one each program's own page names (BS; BSBA for Business, whose page
// names the Bachelor of Science in Business Administration; BPS for
// Professional Studies). The finder tags only some majors with a
// school, so all sit in one group. The KB's majors list was the starting
// point; Clarkson's pages win.
const majors = {
    "slug": "clarkson-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Clarkson's official program finder, with the degree it leads to. Clarkson's finder does not name a school for every major, so they are listed together. Minors, advising tracks, exploratory first-year options, microcredentials and graduate programs are left out.",
    "groups": [
        {
            "name": "Undergraduate majors",
            "source": {
                "label": "Clarkson University, Majors & Minors (Undergraduate Education)",
                "url": "https://www.clarkson.edu/academics/majors-minors?search=&typeSet=Undergraduate+Education"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Applied Mathematics and Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Business",
                    "degree": "BSBA"
                },
                {
                    "name": "Business Analytics",
                    "degree": "BS"
                },
                {
                    "name": "Business of Biotechnology",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Engineering and Management",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Science and Sustainability",
                    "degree": "BS"
                },
                {
                    "name": "Financial Information and Analysis",
                    "degree": "BS"
                },
                {
                    "name": "Global Supply Chain Management",
                    "degree": "BS"
                },
                {
                    "name": "Healthcare",
                    "degree": "BS"
                },
                {
                    "name": "Healthcare Business",
                    "degree": "BS"
                },
                {
                    "name": "Information Systems",
                    "degree": "BS"
                },
                {
                    "name": "Innovation and Entrepreneurship",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Professional Studies",
                    "degree": "BPS"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Software Engineering",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
